import { atom } from "jotai";

export const rendimientoAtom = atom([]);
